import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import Multiselect from 'vue-multiselect'

export default {
  name: 'confirm-line-haul-connection',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    Multiselect,
    VueElementLoading
  },
  data: function() {
    return {
      isLoading: false,
      resultCount: 0,
      hubName: '',
      srcHubName: '',
      srcConnectionName: '',
      srcConnectionNameData: [],
      HubNameData: [],
      DestHubNameData: [],
      allHubMaster: [],
      hubid: '',
      hubNameObjData: {
        value: "",
        text: ""
      },
      srcConnectionObjData: {
        value: "",
        text: ""
      },
      ConnectionError: '',
      connectionRight: '',
      createdBy: '',
      hubLoading: '',
      connectionLoading: '',
      RouteMode: '',
      FromDate: '',
      ToDate: '',
      validDateRange: new Date(),
      displayConnectionSchedule: false,
      lineHaulBagDetails: false,
      isColoaderError: '',
      coloaderlist: [],
      coloaderitem: {
        id: '',
        text: ''
      },
      coright: '',
      confirmLHC: {
        coloaderid: '',
        coloadername: '',
      },
      LineHaulDetailsLstAll: [],
      coloadername: '',
      coloaderid: '',
      today: '',
      isConnectionError: 0,
      ConnectionError: '',
      isColoaderError: 0,
      ColoaderError: '',
      totalRows: 0,
      checkedProducts:[],
      previewModal:false,
      tfNAme:'',
      totalBags:'',
      totalLhBags:'',
      totalPhyWt:'',
      totalVolWt:'',
      parent:{id:'',text:''},
      parentid:'',
      parentList:[],
      invoicenb:'',
      ConfirmConn:'',
      parentCSMID:'',
      childCSMID:'',
      childcsmidarray:[],
      invalidTokenModal: false,
      invalidtokenmsg: '',
    }
  },

  created: function() {},
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.hubid = userdetail[0].HubId[0];
    this.createdBy = userdetail[0].email;
    this.today = new Date()
    this.getHubName();
    this.getLoginHubName(userdetail[0].HubId);
  },
  created() {
  },
  methods: {
    getLoginHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
            this.hubNameObjData={
              value:this.hubid ,
              text: result.data.ResponseData[0].HubName + ' (' + this.hubid + ')'
            }
						// this.srcHubName = result.data.ResponseData[0].HubName;
            this.getConnectionName(this.hubid);
					} else {
						this.hubName = '';
					}
				}, error => {
					console.error(error)
				})
		},
    logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
    selectParent(parent) {
      this.parent = parent
      this.parentCSMID=parent.id
      this.parentid = parent.text
      this.invoicenb = parent.text
      this.tfNAme=parent.trainname
      let index = this.childcsmidarray.indexOf(this.parentCSMID);
      if (index > -1) {
        this.childcsmidarray.splice(index, 1);
      }
      this.childCSMID = this.childcsmidarray.join(",")
    },
    openParentInvoice(){
      if(this.checkedProducts.length<2){
        this.$alertify.error("Invalid! Select atleast 2 schedules for merge operation")
        return false;
      }
      var sumPhy =0;
      var sumVol=0;
      var sumBags=0;
      var sumLhBags=0;

      for (var i = 0; i < this.checkedProducts.length; i++) {
        this.childcsmidarray.push(this.checkedProducts[i].connectionschedulemasterid)
        this.parentList.push({
          id:this.checkedProducts[i].connectionschedulemasterid,
          text:this.checkedProducts[i].invoiceno,
          trainname:this.checkedProducts[i].lhtrainflightdetailsid
        })
        if(this.checkedProducts[i].physicalweight){
          sumPhy+=Number(this.checkedProducts[i].physicalweight)
        }
        if(this.checkedProducts[i].volumetricweight){
          sumVol+=Number(this.checkedProducts[i].volumetricweight)
        }
        if(this.checkedProducts[i].noofbags){
          sumBags+=Number(this.checkedProducts[i].noofbags)
        }
        if(this.checkedProducts[i].totallinehaulbags){
          sumLhBags+=Number(this.checkedProducts[i].totallinehaulbags)
        }
      }
      this.totalPhyWt = sumPhy
      this.totalVolWt = sumVol
      this.totalLhBags = sumLhBags
      this.totalBags = sumBags
      this.previewModal = true
    },
    closeUpdateRowModal(){
      this.tfNAme=''
      this.parentCSMID=''
      this.previewModal = false
      this.totalBags=''
      this.totalLhBags=''
      this.totalPhyWt=''
      this.totalVolWt=''
      this.parent={id:'',text:''}
      this.parentid=''
      this.parentList=[]
      this.invoicenb='',
      this.ConfirmConn=''
      this.parentCSMID='',
      this.childCSMID='',
      this.childcsmidarray=[]
		},
    mergeConnectionSchedule(){
        this.Loading = true
        this.isLoading = true;
        this.input = ({
          "LastModifiedBy": this.createdBy,
          "ParentConnectionScheduleId": this.parentCSMID,
          "ChildConnectionScheduleIds": this.childCSMID
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'mergeConnectionSchedules',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            this.Loading = false
            this.isLoading = false;
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.resetSearchForm();
              this.$alertify.success(result.data.ReturnMessage)
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.Loading = false
            console.error(error)
          })
    },
    selectedConnection(connectionName) {
      this.ConnectionError = ''
      this.srcConnectionObjData = connectionName;
      this.connectionName = connectionName.value;
      this.srcConnectionName = connectionName.value;
      this.coloaderlist = [];
      this.coloaderitem = {
        id: '',
        text: ''
      };
      this.isConnectionError = 0;
      this.ConnectionError = '';
      this.isColoaderError = 0;
      this.ColoaderError = '';
      this.getColoder();
    },

    getHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var HubNameData = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.DestHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
            this.HubNameData = this.DestHubNameData
            this.allHubMaster = this.DestHubNameData
          }
        }, error => {
          console.error(error)
        })
    },
    getConnectionName(hubvalue) {
      this.connectionLoading = 'Loading Connection...'
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var self = this;
      self.srcConnectionNameData = []
      this.resultCount = 0;
      if (hubvalue == undefined || hubvalue == null) {
        return false
      }
      this.input = {
        source: parseInt(hubvalue),
        "type": 3
      }
      this.isLoading = true
      self.connectionRight = this.rightLoader
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getroutemaster',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.connectionLoading = ''
          self.connectionRight = ''
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            var srcConnectionNameData = result.data.ResponseData
            this.isConnectionError = 0;
            this.ConnectionError = ''
            for (i = 0; i < srcConnectionNameData.length; i++) {
              this.srcConnectionNameData.push({
                value: srcConnectionNameData[i].ConnectionID,
                text: srcConnectionNameData[i].ConnectionName
              })
            }
          } else {
            this.isConnectionError = 1;
            this.ConnectionError = 'No Connection Found'
          }
        }, error => {
          self.connectionRight = ''
          this.isLoading = false
          this.connectionLoading = ''
          this.isConnectionError = 0;
          this.ConnectionError = ''
          this.$alertify.error('error in connection api')
          console.error(error)

        })
    },

    SelectColoader(coloaderitem) {
      this.coloaderitem = coloaderitem;
      this.confirmLHC.coloadername = this.coloaderitem.text;
      this.confirmLHC.coloaderid = this.coloaderitem.id;
      if (this.confirmLHC.coloadername != '') {
        this.isColoaderError = '',
          this.Coloadererror = ''
      } else {
        this.isColoaderError = '1',
          this.Coloadererror = 'No Coloader Found'
      }
      this.isColoaderError = 0;
      this.ColoaderError = ''
    },
    jsUcfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getColoder(issearch) {
      this.confirmLHC= {
        coloaderid: '',
        coloadername: '',
      },
      this.coloaderitem = {
        id: '',
        text: ''
      };
      this.coloaderlist=[]
      this.input = {
        hubid: this.hubNameObjData.value,
        connectionid: this.srcConnectionObjData.value,
        mode: this.jsUcfirst(this.RouteMode),
        isactive: 1
      };
      self.coright = self.ddloader
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getcoloadermapping',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          self.coright = ''
          if (result.data.ResultCode == 100) {
            this.ColoderDetails = result.data.ResponseData
            this.isColoaderError = 0;
            this.ColoaderError = ''
            for (var i = 0; i < this.ColoderDetails.length; i++) {
              this.coloaderlist.push({
                "id": this.ColoderDetails[i].ColoaderID,
                "text": this.ColoderDetails[i].ColoaderName
              })
            }
          } else {
            this.isColoaderError = 1
            this.ColoaderError = 'No Coloader Found'
          }
        }, error => {
          self.coright = ''
          this.isColoaderError = 0;
          this.ColoaderError = ''
          console.error(error)
        })
    },
    showConnectionSchedule() {
      this.totalRows = 0
      if ( this.FromDate == '' || this.ToDate == '') {
        return false;
      }
      this.isLoading = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getPendingConnectionsForMerge?hubID=' + this.hubNameObjData.value + '&routeMode=' + this.RouteMode + '&lineHaulStatus=Pending' + '&connectionID=' + this.srcConnectionObjData.value + '&coloaderID=' + this.coloaderitem.id + '&fromDate=' + moment(this.FromDate).format('YYYY-MM-DD') + '&toDate=' + moment(this.ToDate).format('YYYY-MM-DD') + '',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          this.lineHaulBagDetails = false;
          this.$validator.reset();
          this.errors.clear();
          if (result.data.ResultCode == 100) {
            this.displayConnectionSchedule = true;
            this.LineHaulDetailsLstAll = result.data.ResponseData;
            this.totalRows = result.data.TotalCount
          } else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					}else {
            this.displayConnectionSchedule = false;
            this.LineHaulDetailsLstAll = []
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          self.coright = ''
          console.error(error)
        })
    },
    onSubmitSearch: function() {
      var self = this
      this.$validator.validateAll('form-1').then((result) => {
        if (!result) {
          return false;
        }
        this.showConnectionSchedule();
      }).catch(() => {
        console.log('errors exist')
      });
    },

    resetSearchForm() {
      this.coloaderlist=[]
      this.coloaderitem = {
        id: '',
        text: ''
      };
      this.confirmLHC= {
        coloaderid: '',
        coloadername: '',
      },
      this.parentCSMID='',
      this.childCSMID='',
      this.childcsmidarray=[]
      this.checkedProducts=[]
      this.previewModal=false
      this.tfNAme=''
      this.totalBags=''
      this.totalLhBags=''
      this.totalPhyWt=''
      this.totalVolWt=''
      this.parent={id:'',text:''}
      this.parentid=''
      this.parentList=[]
      this.invoicenb='',
      this.ConfirmConn=''
      this.isLoading = false;
      this.srcConnectionName = '';
      this.RouteMode = '';
      this.srcConnectionObjData = {
        value: "",
        text: ""
      };
      this.coloaderitem = {
        id: '',
        text: ''
      };
      this.FromDate = '';
      this.ToDate = '';
      this.isConnectionError = 0;
      this.ConnectionError = '';
      this.isColoaderError = 0;
      this.ColoaderError = '';
      this.LineHaulDetailsLstAll = [];
      this.displayConnectionSchedule = false;
      this.lineHaulBagDetails = false;
      this.$validator.reset();
      this.errors.clear();
      this.srcHubName = ''
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/components/MergeConnectionSchedule/MergeConnectionSchedule.js